import React from 'react';
import { renderToString } from 'react-dom/server';

import { FileAudioIcon } from '../../../icon/regular';
import {
  InstructionCSSClasses,
  InstructionEvent,
  InstructionActionTooltip,
} from '../types';
import { addInstructionEvent, emitInstructionEvent } from '../utils';
import BlockInstruction from '../base-instruction/BlockInstruction';

class AudioInstructionBlock extends BlockInstruction {
  static initiable = false;

  get isInit() {
    return AudioInstructionBlock.initiable;
  }

  set isInit(value: boolean) {
    AudioInstructionBlock.initiable = value;
  }

  get instructionClasses() {
    return {
      wrapper: InstructionCSSClasses.AUDIO_INSTRUCTION_BLOCK,
      action: InstructionCSSClasses.AUDIO_INSTRUCTION_BLOCK_ACTION,
      content: InstructionCSSClasses.AUDIO_INSTRUCTION_BLOCK_CONTENT,
    };
  }

  static get toolbox() {
    return {
      icon: renderToString(<FileAudioIcon style={{ height: 20 }} />),
      title: 'Audio',
    };
  }

  get tooltip() {
    return InstructionActionTooltip.audio;
  }

  openModal(instructionId: string) {
    emitInstructionEvent(
      this.api.events,
      InstructionEvent.OPEN_AUDIO_INSTRUCTION_MODAL,
      {
        instructionId,
        isInline: false,
      },
    );
  }

  initEvents(): void {
    this.saveInstruction = this.saveInstruction.bind(this);
    addInstructionEvent(
      this.api.events,
      InstructionEvent.SAVE_AUDIO_INSTRUCTION_BLOCK,
      this.saveInstruction,
    );
  }

  removeEvents(): void {
    this.api.events.off(
      InstructionEvent.SAVE_AUDIO_INSTRUCTION_BLOCK,
      this.saveInstruction,
    );
  }
}

export default AudioInstructionBlock;
